import React from 'react';
import { Box, Grid, Typography, makeStyles } from '@material-ui/core';
import moment from 'moment-timezone';
import StatusChipUnits from '../../../../components/StatusChip/StatusChipUnits';
import { formatLicenceStateLabel } from './licenceStateUtils';

const useStyles = makeStyles({
  fieldLabel: {
    display: 'block',
    marginBottom: 2,
    lineHeight: 1.2,
  },
  fieldValue: {
    marginBottom: 8,
    lineHeight: 1.4,
    wordBreak: 'break-word',
  },
});

const formatDisplayValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return String(value);
};

const formatDateValue = (value) => {
  if (!value) {
    return '—';
  }
  const date = moment(value);
  return date.isValid() ? date.format('YYYY-MM-DD') : '—';
};

const ViewField = ({ label, children, classes }) => (
  <Box>
    <Typography variant="caption" color="textPrimary" className={classes.fieldLabel}>
      {label}
    </Typography>
    <Typography
      variant="body2"
      color="textPrimary"
      component="div"
      className={classes.fieldValue}
    >
      {children}
    </Typography>
  </Box>
);

const PermitCardView = ({ values }) => {
  const classes = useStyles();
  const status = String(values?.status || '')
    .toLowerCase()
    .trim();

  return (
    <Box px={2} pb={1}>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <ViewField label="Status" classes={classes}>
            {status ? (
              <StatusChipUnits status={status} />
            ) : (
              formatDisplayValue(values?.status)
            )}
          </ViewField>
        </Grid>
        <Grid item xs={6}>
          <ViewField label="Expiration Date" classes={classes}>
            {formatDateValue(values?.expiration_date)}
          </ViewField>
        </Grid>
        <Grid item xs={12}>
          <ViewField label="License Plate" classes={classes}>
            {formatDisplayValue(values?.licence_plate)}
          </ViewField>
        </Grid>
        <Grid item xs={12}>
          <ViewField label="Licence State" classes={classes}>
            {formatLicenceStateLabel(values?.licence_state)}
          </ViewField>
        </Grid>
        <Grid item xs={6}>
          <ViewField label="Make" classes={classes}>
            {formatDisplayValue(values?.make)}
          </ViewField>
        </Grid>
        <Grid item xs={6}>
          <ViewField label="Model" classes={classes}>
            {formatDisplayValue(values?.model)}
          </ViewField>
        </Grid>
        <Grid item xs={12}>
          <ViewField label="Color" classes={classes}>
            {formatDisplayValue(values?.color)}
          </ViewField>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PermitCardView;
